"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PDFAnnotationType = void 0;
/**
 * PDF 标注类型
 */
var PDFAnnotationType;
(function (PDFAnnotationType) {
    PDFAnnotationType["RECTANGLE"] = "rectangle";
    PDFAnnotationType["ELLIPSE"] = "ellipse";
    PDFAnnotationType["POLYGON"] = "polygon";
    PDFAnnotationType["HIGHLIGHT"] = "highlight";
})(PDFAnnotationType = exports.PDFAnnotationType || (exports.PDFAnnotationType = {}));
